import type { WeekStatus } from "@/lib/types";

type Props = { status: WeekStatus; className?: string };

const COPY: Record<WeekStatus, { label: string; cls: string }> = {
  open:    { label: "🟡 Mở",     cls: "bg-yellow-50 text-yellow-500 border border-yellow-100" },
  approved:{ label: "🔵 Đã duyệt", cls: "bg-blue-50  text-blue-500   border border-blue-100"  },
  paid:    { label: "🟢 Đã trả",   cls: "bg-green-50 text-green-600  border border-green-100" },
};

export function StatusBadge({ status, className = "" }: Props) {
  const c = COPY[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold ${c.cls} ${className}`}
    >
      {c.label}
    </span>
  );
}
